/**
 * StartupServices.jsx — Iter 50.
 * Wraps the unified Services marketplace + per-category Engagements tab.
 */
import React from 'react';
import MarketplaceTabsShell from '../../../components/MarketplaceTabsShell';

const StartupServices = () => <MarketplaceTabsShell category="service" />;
export default StartupServices;
